import { CoreApi, Product, ProductType } from '@inter-ikea-storageone/range';
import {
  matchDepth,
  matchDimensions,
  matchWidth
} from 'rangeConfig/shared/filters/selectedMenuProductFilters';

/**
 * Shelves and bottle racks should be replaceable even thought they don't have same height
 * otherwise all dimensions should match to be able to replace
 */
export const matchInteriorType = (coreApi: CoreApi, selectedProduct: Product) => (
  product: Product
) => {
  const shelvesAndBottleRack = [
    ProductType.IVAR_SHELF_PINE,
    ProductType.IVAR_SHELF_FELT,
    ProductType.IVAR_SHELF_METAL,
    ProductType.IVAR_BOTTLE_RACK
  ];
  return shelvesAndBottleRack.includes(selectedProduct.type)
    ? shelvesAndBottleRack.includes(product.type) &&
        matchWidth(coreApi, selectedProduct)(product) &&
        matchDepth(coreApi, selectedProduct)(product)
    : matchDimensions(coreApi, selectedProduct)(product);
};
